import api from "../services/api";

// All subscription APIs use centralized API service with interceptors
export const getPlans = async () => {
  return api.get("/api/subscriptions/plans");
};

export const getUserSubscription = async () => {
  return api.get("/api/subscriptions/current");
};

export const createOrder = async (planName, billingPeriod = 'monthly', customAmount = null) => {
  return api.post("/api/subscriptions/create-order", { 
    plan_name: planName,
    billing_period: billingPeriod,
    amount: customAmount // If provided, use this amount instead of plan default
  });
};

export const verifyPayment = async (paymentData) => {
  return api.post("/api/subscriptions/verify-payment", paymentData);
};

export const checkAccess = async (requiredPlan) => {
  return api.get("/api/subscriptions/check-access", {
    params: { required_plan: requiredPlan },
  });
};

export const getSubscriptionHistory = async () => {
  return api.get("/api/subscriptions/history");
};

export const checkFlowAccess = async () => {
  return api.get("/api/subscriptions/check-flow-access");
};

export const getAddonPlans = async () => {
  return api.get("/api/subscriptions/addon-plans");
};

export const createAddonOrder = async (addonId, billingPeriod = 'monthly') => {
  return api.post("/api/subscriptions/create-addon-order", { 
    addon_id: addonId, 
    billing_period: billingPeriod 
  });
};

export const verifyAddonPayment = async (paymentData) => {
  return api.post("/api/subscriptions/verify-addon-payment", paymentData);
};

// AI Credit APIs
export const getUserCredits = async () => {
  return api.get("/api/subscriptions/credits");
};

export const getCreditPlans = async () => {
  return api.get("/api/subscriptions/credit-plans");
};

export const getCreditAddingPlan = async () => {
  return api.get("/api/subscriptions/credit-adding-plan");
};

export const createCreditOrder = async (creditPlanId, creditsAmount) => {
  return api.post("/api/subscriptions/create-credit-order", { 
    credit_plan_id: creditPlanId,
    credits_amount: creditsAmount,
  });
};

export const verifyCreditPayment = async (paymentData) => {
  return api.post("/api/subscriptions/verify-credit-payment", paymentData);
};

